export default __webpack_public_path__ + "static/mechenism-ea3f1271e1df10c8ef2dd577be79823f.mp4";